import React, { createContext, useEffect, useState } from "react";
import db from "../api/mongodb"
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

// Create two context:
// UserContext: to query the context state
// UserDispatchContext: to mutate the context state
const UserContext = createContext(undefined);
const UserDispatchContext = createContext(undefined);

// A "provider" is used to encapsulate only the
// components that needs the state in this context


class FetchError extends Error {
    constructor( res, message) {
      super(message)
    }
}

const getRequestFromAPI = async (route) => {
    const response =await db.get(route);
    const responseJson = response.data
    if (!(response.status === 200)) {
        return Promise.reject(new FetchError(response, responseJson.message));
    } else {
        return Promise.resolve(responseJson);
    }
};


export const useGetLoggedInUserQuery = ()=> useQuery({
    queryKey:['user','getLoggedInUser'],
    queryFn:()=> getRequestFromAPI("api/safeAPs/isLoggedIn"),
    refetchInterval: 30000, // Fetch every 30 seconds
    refetchIntervalInBackground: true, // Only refetch if the window is focused
    
    
})
function UserProvider({ children }) {
    const [userDetails, setUserDetails] = useState({});
    const location = useLocation()
    const navigate = useNavigate()
    
    const userQuery = useGetLoggedInUserQuery()
    
    useEffect(()=>{
        if(userQuery.data){
            setUserDetails(userQuery.data)
        }
        // console.log(userQuery.status)
        // console.log(userQuery.fetchStatus)
        if(userQuery.status==="error"&&userQuery.fetchStatus!=="fetching"&&userQuery.error){
            // console.log(userQuery.error.response)
            if(userQuery.error.response.status === 401 &&  location.pathname !== `/` &&
                location.pathname !==`/registration` &&
                location.pathname !==`/forgotPassword` &&
                location.pathname !==`/termsAndConditions`&&
                location.pathname !==`/2faPage`&&
                // location.pathname !==`/createBestPractice`&&
                !location.pathname.includes(`/projectInvite`)&&
                !location.pathname.includes(`/directory`)&&
                !location.pathname.includes(`/passwordReset`)&&
                !location.pathname.includes(`/publicClientQuestionnaire`)){
                navigate("/")
            }
        }
       
    },[userQuery.fetchStatus,userQuery.status, userQuery.data])

    // useEffect(()=>{
    //     db
    //         .get(`api/safeAPs/isLoggedIn`, {
    //             headers: {
    //                 Authorization: `${localStorage.getItem("token")}`,
    //             },
    //         })
    //         .then((user) => {
    //             setUserDetails(user.data)
                
    //         })
    //         .catch((error) => {
    //             // console.log(error)
    //             if (error.response.status === 401) {
    //                 // navigate("/")
    //                 return
    //             }

    //         })
    // },[location.pathname])

    return (
        <UserContext.Provider value={userDetails}>
            <UserDispatchContext.Provider value={setUserDetails}>
                {children}
            </UserDispatchContext.Provider>
        </UserContext.Provider>
    );
}

export { UserProvider, UserContext, UserDispatchContext };
